import React from 'react';
import { Collapse, Tag } from 'antd';
import { DraftOrder, Order } from 'services/hitchit/types/online-sales/Order';
import { Product } from 'services/hitchit/types/online-sales/Product';

const { Panel } = Collapse;

export const TriggerCollapse = ({
  trigger,
}: {
  trigger: Order | DraftOrder | Product;
}): JSX.Element => {
  switch (trigger.type) {
    case 'order':
    case 'draft':
      return <OrderCollapse order={trigger} />;
    case 'product':
      return <ProductCollapse product={trigger} />;
    default: {
      console.error('unknown trigger', trigger);
      throw new Error(`Unknown trigger type: ${(trigger as unknown as any).type}`);
    }
  }
};

const ProductCollapse = ({ product }: { product: Product }): JSX.Element => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Tag color="orange">{product.isDummy ? 'Dummy Product Variant' : 'Product Variant'}</Tag>
        {product.image && (
          <img src={product.image.src} alt={product.image.alt || product.title} width="100" />
        )}
      </div>
      <Collapse ghost>
        <Panel
          key={product.title}
          header={`Product: ${product.title} - ${product.variant?.title} - ${product.vendor}`}
        >
          {product.variant && (
            <Collapse ghost>
              <Panel
                header={`${product.title} - ${product.variant.price} ${product.variant.inventory_quantity}`}
                key={product.variant.id}
              >
                <p>{`SKU: ${product.variant.sku || product.variant.inventoryItem?.sku || ''}`}</p>
                <p>{`Stock: ${product.variant.inventory_quantity || ''}`}</p>
                <p>{`Tags: ${product.tags || ''}`}</p>
                <p>{`Cost: ${product.variant.inventoryItem?.cost || ''}`}</p>
                <p>{`System Code: ${
                  product.variant.inventoryItem?.harmonized_system_code || ''
                }`}</p>
                <p>{`Tax Code: ${product.variant.tax_code || ''}`}</p>
              </Panel>
            </Collapse>
          )}
        </Panel>
      </Collapse>
    </>
  );
};
const OrderCollapse = ({ order }: { order: Order | DraftOrder }): JSX.Element => {
  let tag = (order as Order).type === 'order' ? 'Order' : 'Draft order';
  tag = (order as Order).isDummy ? 'Dummy ' + tag : tag;

  return (
    <>
      <Tag color="orange">{tag}</Tag>
      <Collapse ghost>
        <Panel
          key={order.name}
          header={`Order: ${order.name} - ${order.total_price} ${order.currency}`}
        >
          <Collapse ghost>
            {order.line_items &&
              order.line_items.map((lineItem, index) => (
                <Panel
                  header={`${lineItem.title} - ${lineItem.price} ${order.currency}`}
                  key={index}
                >
                  <p>{`Name: ${lineItem.name}`}</p>
                  <p>{`Quantity: ${lineItem.quantity}`}</p>
                </Panel>
              ))}
          </Collapse>
        </Panel>
      </Collapse>
      {order.customer && (
        <Collapse ghost>
          <Panel
            key={order.name}
            header={`Customer: ${order.customer.first_name} ${order.customer.last_name}`}
          >
            <p>Email: {order.customer.email}</p>
            <p>Phone: {order.customer.phone || order.customer?.default_address?.phone}</p>
            {order.customer.default_address && (
              <p>
                Address: {order.customer.default_address.address1}{' '}
                {order.customer.default_address.address2} - {order.customer.default_address.zip}{' '}
                {order.customer.default_address.city} - {order.customer.default_address.country}
              </p>
            )}
          </Panel>
        </Collapse>
      )}
    </>
  );
};
